import { createSlice } from "@reduxjs/toolkit";
import { DASHBOARD_TYPE } from "../../pages/insight/lite/utils";

const INIT_STATE = {
  openModal: false,
  dashboardType: DASHBOARD_TYPE.ED,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: INIT_STATE,
  reducers: {
    setOpenDashboardModal: (state, type) => {
      state.openModal = type.payload;
    },
    setDashboardType: (state, type) => {
      state.dashboardType = type.payload;
    },
  },
});

// Setters
export const { setOpenDashboardModal, setDashboardType } =
  dashboardSlice.actions;

// Variable
export const dashboardModalOpen = (state) => state.dashboard.openModal;
export const dashboardType = (state) => state.dashboard.dashboardType;

export default dashboardSlice.reducer;
